export default __webpack_public_path__ + "static/media/resetpass.571cc451.png";